import {combineReducers} from 'redux';

import instiutionPermissions from './instiutionPermissions';
import userPermissions from './userPermissions';

export const permissionsReducer = combineReducers({
  instiutionPermissions,
  userPermissions,
});
